import BuyerAppointmentsPdf from './BuyerAppointmentsPdf';

export default BuyerAppointmentsPdf;
